import {Link} from 'react-router-dom';
import {ESSAYS} from '../content/essays';
import Seo from "./Seo";

export default function AcademicWritings() {
    return (
        <main className="cx-page"><div className="cx-col">
            <Seo title="Academic Writings" path="/academic-writings"
                 description="Academic essays on ecology, extinction, ecopoetics, and the environmental humanities." />

            <div className="aw-head">
                <h1>Academic Writings</h1>
                <p className="intro">A few essays that reflect what I'm studying</p>
            </div>

            <div className="aw-list">
                {ESSAYS.map((e) => (
                    <article className="aw-entry" key={e.id}>
                        <Link className="aw-title" to={`/academic-writings/${e.slug}`}>
                            {e.title}<span className="aw-arrow">&nbsp;→</span>
                        </Link>
                        {e.subtitle && <p className="aw-sub">{e.subtitle}</p>}
                        {e.blurb && <p className="aw-blurb">{e.blurb}</p>}
                        <p className="aw-meta">
                            {[e.course, e.year, ...(e.tags || [])].filter(Boolean).join(' · ')}
                        </p>
                    </article>
                ))}
            </div>
        </div></main>
    );
}